import { api } from '../api';
import { Profile } from '../../entities/Profile';

// `numberOfUsers` mantido por compatibilidade de assinatura; o backend
// (GET /roles, RBAC em código) ignora e sempre retorna `userCount`.
export const getProfiles = async (
  _numberOfUsers?: number,
): Promise<Profile[]> => {
  const { data } = await api.get('/roles');

  return data;
};
